import React from 'react'
import { AddOnsData, CategoryData, TemperatureResponseData } from '../../../features/setup/setupResponse';
import { setUpAddons, setUpCategory } from '../../../data/admin-data';
import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import { useDispatch } from 'react-redux';
import { setPopulateAddons, setPopulateCategory, setPopulateTemperature, setSetup, setSetupTypeId } from '../../../features/setup/setupSlice';

interface SetupAddonsTBodyProps {
    data: AddOnsData[];
    isLoading: boolean
    isError: boolean
    errorMessage: string;
    isEmpty: boolean
}

export default function SetupAddonsTBody({ data, isLoading, isEmpty, errorMessage, isError }: SetupAddonsTBodyProps) {
    
    const dispatch = useDispatch()

    return (
        <tbody className='w-full'>
            {isLoading ? (
                <tr>
                    <td colSpan={setUpAddons.length}  className='h-auto text-center'> 
                        <div className="flex space-x-1 justify-center items-center w-full h-full">
                            <Loading message="Loading product..." />
                        </div>
                    </td>
                </tr>
            ) : isError ? (
                <tr>
                    <td colSpan={setUpAddons.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <ErrorMessage message={errorMessage} textStyle={``}/>
                        </div>
                    </td>
                </tr>
            ) : isEmpty ? (
                <tr>
                    <td colSpan={setUpAddons.length}  className="py-8">
                        <div className="flex items-center justify-center w-full text-xs">
                            <p className='text-gray-500 text-xs'>No result found.</p>
                        </div>
                    </td>
                </tr>
            ) : (
                data.map((data, index) => {
                    const isActive = data.isActive ? 'Active' : 'Inactive'
                    return (
                        <tr 
                            key={data.addonID} 
                            className={`hover:bg-gray-100 text-xs cursor-pointer ${index % 2 === 0 ? "bg-white" : "bg-gray-100"}`}
                        >
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-medium">
                                        {data.addonName}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <span
                                    className={`inline-flex rounded px-2 py-0.5 text-xs font-medium ${
                                        data.isActive
                                            ? "bg-green-100 text-green-700"
                                            : "bg-red-100 text-red-700"
                                    }`}
                                >
                                    {isActive}
                                </span>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-medium">
                                        {data.price}
                                </div>
                            </th>
                            <th className="capitalize px-2.5 py-1.5 text-left border border-gray-200">
                                <div className="truncate font-normal">
                                    <div className="col-span-2 font-medium truncate">
                                        <button
                                            onClick={() => {
                                                dispatch(setPopulateAddons({ addonName: data.addonName, price: data.price, isAvailable: data.isActive }))
                                                dispatch(setSetupTypeId(data.addonID))
                                                dispatch(setSetup({ type: 'show', value: 'setUpAddons'}))
                                                dispatch(setSetup({ type: 'update', value: 'setUpAddonsUpdate'}))
                                            }}
                                            className="text-cbColor text-xs px-4 py-1.5 rounded transition"
                                        >
                                            Edit
                                        </button>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    )
                })
            )}
        </tbody>
    )
}
